import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./home.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import LeftOffListings from 'ace/leftOffListings';
import Listings from 'ace/listings';
import Recommendations from 'ace/recommendations';
import TopCategories from 'ace/topCategories';
import WordpressSlugContent from 'cms/wordpressSlugContent';
import CardContent from 'wds/tilesGridContainer';
import Toast from 'wds/toast';
import { initialPageRenderedMetricsCheck } from '~/modules/services/metricsService';
import { contentStore } from '~/modules/stores/contentStore';
import { WireI18n, i18nStore } from '~/modules/stores/i18nStore';
import { selectIsGuestUser, userStore } from '~/modules/stores/userStore';
import { wordPressStore } from '~/modules/stores/wordpress_store';
import { logger } from '~/modules/utilities/cross_env_utils';
// This function maps types from the home_content service to UI components
function loadComponent(type) {
  const componentMapping = {
    sponsored: Listings,
    link_based: Listings,
    top_trending: Listings,
    recommended: Recommendations,
    article_content: CardContent,
    category: TopCategories,
    wordpress_slug_content: WordpressSlugContent,
    pick_up: LeftOffListings,
    toast: Toast
  };
  if (!componentMapping[type]) {
    throw new Error('Invalid component: ' + type + ', unknown constructor');
  }
  return componentMapping[type];
}
class Home extends LightningElement {
  constructor(...args) {
    super(...args);
    this.sections = [];
    this.isError = false;
    this.isGuestUser = true;
  }
  i18nCallback() {
    wordPressStore.setLanguage(i18nStore.getState().currentLanguage);
  }
  setCurrentUser(isGuestUser) {
    //if user has just logged in or out, force reload of content
    const forceReload = this.isGuestUser !== isGuestUser;
    this.isGuestUser = isGuestUser;
    this.fetchSections(forceReload);
  }
  fetchSections(forceReload = false) {
    contentStore.fetchSections(this.isGuestUser, forceReload).catch(error => {
      logger.error(`There was a problem fetching sections: ${error}`);
      this.isError = true;
    });
  }

  // @ts-expect-error * Automated Type Error Fix
  setSections(sections) {
    sections?.forEach(section => {
      this.loadSection(section);
    });

    // Remove loaded sections that no longer exist
    for (let i = this.sections.length - 1; i >= 0; --i) {
      const loadedSection = this.sections[i];
      const shouldExist = sections?.some(test => test.props.id === loadedSection.props.id);
      if (!shouldExist) {
        this.sections.splice(i, 1);
      }
    }
  }
  loadSection(section) {
    try {
      const existingSection = this.sections.find(test => test.props.id === section.props.id);

      // Don't load the same section twice
      if (existingSection) {
        return;
      }
      const constructor = loadComponent(section.type);
      const key = section.props.id;
      const component = {
        ...section,
        key,
        constructor
      };
      this.sections.push(component);
    } catch (error) {
      logger.error(`Can't load section of type ${section.type}.`);
      logger.debug(JSON.stringify(section));
    }
  }
  renderedCallback() {
    if (this.sections?.length > 0) {
      initialPageRenderedMetricsCheck();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Home, {
  track: {
    sections: 1
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    setCurrentUser: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectIsGuestUser
        };
      }
    },
    setSections: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: contentStore,
          selector: state => state.sections
        };
      }
    }
  },
  fields: ["isError", "isGuestUser"]
});
const __lwc_component_class_internal = _registerComponent(Home, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;